import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  ReactNode,
} from 'react';

interface SalesCopilotModalStore {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

const SalesCopilotModalContext = createContext<SalesCopilotModalStore | null>(
  null
);

export function SalesCopilotModalProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  const value: SalesCopilotModalStore = {
    isOpen,
    openModal,
    closeModal,
  };

  return (
    <SalesCopilotModalContext.Provider value={value}>
      {children}
    </SalesCopilotModalContext.Provider>
  );
}

export function useSalesCopilotModalStore(): SalesCopilotModalStore {
  const context = useContext(SalesCopilotModalContext);
  if (!context) {
    throw new Error(
      'useSalesCopilotModalStore must be used within SalesCopilotModalProvider'
    );
  }
  return context;
}
